import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Pipe({
  name: 'base64',
  standalone: true,
})
export class Base64Pipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}

  transform(value: any, ...args: unknown[]): SafeUrl {
    return this.domSanitizer.bypassSecurityTrustUrl(
      'data:image/jpg;base64,' + value,
    );
  }
}
